import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import { BannerService } from "../../../services/banner-service";
import { DataGrid } from "@material-ui/data-grid";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import PublishIcon from "@material-ui/icons/Publish";
import { STORAGE_BUCKET_ORIGIN } from "../../../config/constants";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import AuthContext from "../../../context/auth-context";

export const Content = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [createHide, setCreateEdit] = useState(true);
  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "BANNERS" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "BANNERS" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }
      if (
        loca.access_module.module_name == "BANNERS" &&
        loca.permission_add === true
      ) {
        setCreateEdit(false);
      }
    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD";
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const [banner, setBannerDetails] = useState([]);

  const formRef = useRef();

  const history = useHistory();

  const [state, setState] = useState(false);

  const [submitloading, setSubmitLoading] = useState(true);

  var bodyFormData = new FormData();

  const [bannerID, setbannerID] = useState();

  const handleShow4 = (e) => {
    setState({ show4: true });
    setbannerID(e);
  };

  const handleShow3 = (e) => {
    setState({ show3: true });
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const [uploadedFile, setUploadedFile] = useState();

  const bannerSearch = async () => {
    try {
      const result = await BannerService.bannerDetails(rowsPerPage, page);

      setBannerDetails(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);
    // input_values = values;

    bodyFormData.append("type", values.type);
    bodyFormData.append("open_type", values.open_type);
    bodyFormData.append("url", values.url);
    bodyFormData.append("description", values.description);
    bodyFormData.append("image", uploadedFile);

    try {
      await BannerService.bannerCreate(bodyFormData);

      setSubmitLoading(true);
      notify("Banner successfully added");
      formRef.current.resetForm();
      bannerSearch();
      handleClose();
      setUploadedFile(null);
    } catch (err) {
      setSubmitLoading(true);

      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
        notifyWarning(err.response.data.message[0]);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await BannerService.bannerDelete(bannerID);

      setSubmitLoading(true);
      notify("Banner successfully deleted");
      handleClose();
      bannerSearch();
    } catch (err) {
      setSubmitLoading(true);
      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    bannerSearch();
  }, [rowsPerPage, page, count]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "image",
      headerName: "Image",
      sortable: false,
      flex: 5,
      disableClickEventBubbling: true,

      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div>
            <img
              alt=""
              src={`${STORAGE_BUCKET_ORIGIN}${params.row.image}`}
              style={{ height: "7vh" }}
            />
          </div>
        );
      },
    },

    {
      field: "type",
      headerName: "Type",
      flex: 5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },

    {
      field: "created_at",
      headerName: "Created Date",
      sortable: false,
      flex: 4,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.created_at).format(format2)}</div>;
      },
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 3,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.status === "ACTIVE") {
          return (
            <div>
              <span className="badge badge-success">ACTIVE</span>
            </div>
          );
        } else {
          return (
            <div>
              {" "}
              <span className="badge badge-primary">DEACTIVE</span>
            </div>
          );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            hidden={editHide}
            onClick={() => {
              history.push(`/banner-edit/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div hidden={deleteHide}>
            <i
              className="far fa-trash-alt ms-text-danger"
              // onClick={handleShow4}
              onClick={() => {
                handleShow4(params.row.id);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <div className="col-md-11">
                      <h6>Banner Management</h6>
                    </div>
                    <div>
                      <Modal
                        show={state.show4}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            Confirm Deletion
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "2vh",
                          }}
                        >
                          <h6 style={{ color: "red" }}>
                            Are you sure you want to remove this item ?
                          </h6>
                        </div>
                        <Modal.Footer>
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary shadow-none"
                            // onClick={submitForm}
                            style={{ backgroundColor: "red" }}
                            onClick={onDelete}
                          >
                            Delete
                          </button>

                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                          >
                            Cancel
                          </button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                    <div className="col-md-1">
                      <div className="col-md-2 col-sm-4">
                        <button
                          type="button"
                          className="ms-btn-icon btn-primary"
                          name="button"
                          onClick={handleShow3}
                          hidden={createHide}
                        >
                          <i className="material-icons">person_add</i>
                        </button>
                      </div>
                      <Modal
                        show={state.show3}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            <i className="flaticon-share bg-primary text-white" />
                            Add New Banner
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <Formik
                          initialValues={{
                            type: "",
                            open_type: "",
                            url: "",
                            description: "",
                            image: "",
                          }}
                          validationSchema={Yup.object().shape({
                            type: Yup.string().required("Required"),
                            open_type: Yup.string().required("Required"),
                          })}
                          onSubmit={onSubmitForm}
                          innerRef={formRef}
                        >
                          {({
                            errors,
                            handleBlur,
                            handleChange,
                            touched,
                            values,
                            submitForm,
                            isValid,
                            setFieldValue,
                          }) => (
                            <div>
                              <Modal.Body>
                                <div className="mb-3">
                                  <label htmlFor="validationCustom15">
                                    Type
                                  </label>
                                  <div className="input-group">
                                    <select
                                      name="type"
                                      className="form-control"
                                      id="selectstatus"
                                      required
                                      value={values.type}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    >
                                      <option value="">
                                        Select Banner Type
                                      </option>
                                      <option value="MAIN_BANNER">
                                        MAIN BANNER
                                      </option>
                                      <option value="SPECIAL_PROMO">
                                        SPECIAL PROMO
                                      </option>
                                      <option value="SPECIAL_MENU">
                                        SPECIAL MENU
                                      </option>
                                      <option value="SHORTCUT">SHORTCUT</option>
                                      <option value="ON_PAGE_LOAD">
                                        ON PAGE LOAD
                                      </option>
                                    </select>
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.type && errors.type}
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <label htmlFor="validationCustom15">
                                    Open Type
                                  </label>
                                  <div className="input-group">
                                    <select
                                      name="open_type"
                                      className="form-control"
                                      id="selectstatus"
                                      required
                                      value={values.open_type}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    >
                                      <option value="">Select Type</option>
                                      <option value="NONE">NONE</option>
                                      <option value="POPUP">POPUP</option>
                                      <option value="URL">URL</option>
                                    </select>
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.open_type && errors.open_type}
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <label htmlFor="validationCustom08">
                                    URL
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="url"
                                      type="text"
                                      className="form-control"
                                      id="urlID"
                                      placeholder="URL"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.url}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.url && errors.url}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label htmlFor="validationCustom08">
                                    Description
                                  </label>
                                  <div className="input-group">
                                    <input
                                      name="description"
                                      type="text"
                                      className="form-control"
                                      id="descriptionID"
                                      placeholder="DESCRIPTION"
                                      required
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.description}
                                    />
                                  </div>
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.description && errors.description}
                                  </div>
                                </div>
                                <div>
                                  <label htmlFor="validationCustom08">
                                    Upload Image
                                  </label>
                                  <img
                                    alt=""
                                    src={
                                      uploadedFile != null
                                        ? URL.createObjectURL(uploadedFile)
                                        : PublishIcon
                                    }
                                  />
                                </div>
                                <div className="mb-3 mt-2">
                                  <input
                                    type="file"
                                    name="image"
                                    onBlur={handleBlur}
                                    onChange={(event) => {
                                      setUploadedFile(event.target.files[0]);

                                      setFieldValue("image", "file");
                                    }}
                                  />

                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.image && errors.image}
                                  </div>
                                </div>

                                <div
                                  className="col-md-2"
                                  hidden={submitloading}
                                >
                                  <div className="spinner spinner-7">
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                  </div>
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  onClick={handleClose}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary shadow-none"
                                  onClick={submitForm}
                                >
                                  Add
                                </button>
                                <div>
                                  <ToastContainer />
                                </div>
                              </Modal.Footer>
                            </div>
                          )}
                        </Formik>
                      </Modal>
                    </div>
                  </div>
                </div>
                <div className="ms-panel-body">
                  <div style={{ height: 650, width: "100%" }}>
                    <DataGrid
                      rows={banner}
                      columns={columns}
                      pageSize={10}
                      page={page}
                      hideFooter
                      autoHeight
                    />

                    <TablePagination
                      component="div"
                      count={count}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
